import { render } from "./VlmTest.vue?vue&type=template&id=62d94f73&scoped=true"
import script from "./VlmTest.vue?vue&type=script&lang=js"
export * from "./VlmTest.vue?vue&type=script&lang=js"

import "./VlmTest.vue?vue&type=style&index=0&id=62d94f73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d94f73"]])

export default __exports__